import { Controller } from "@hotwired/stimulus"

// Steps through the recorded UX walkthrough (/samples/walkthrough) one screen at a time.
// The current step is kept in the URL hash (#step-12) so a step can be linked to.
export default class extends Controller {
  static targets = ["step", "chip", "counter", "progress", "chapter", "prev", "next"]

  connect() {
    this.showFromHash()
  }

  showFromHash() {
    const match = window.location.hash.match(/^#step-(\d+)$/)
    this.show(match ? Number(match[1]) - 1 : 0, { scroll: false })
  }

  next() {
    this.show(this.index + 1)
  }

  previous() {
    this.show(this.index - 1)
  }

  jump(event) {
    this.show(Number(event.currentTarget.dataset.index))
  }

  key(event) {
    if (event.target.closest("input, textarea, select, [contenteditable]")) return
    if (event.key === "ArrowRight") { event.preventDefault(); this.next() }
    if (event.key === "ArrowLeft") { event.preventDefault(); this.previous() }
  }

  show(index, { scroll = true } = {}) {
    const last = this.stepTargets.length - 1
    this.index = Math.min(Math.max(index, 0), last)

    this.stepTargets.forEach((step, i) => { step.hidden = i !== this.index })
    this.chipTargets.forEach((chip, i) => {
      if (i === this.index) chip.setAttribute("aria-current", "step")
      else chip.removeAttribute("aria-current")
    })

    const step = this.stepTargets[this.index]
    this.counterTarget.textContent = this.index + 1
    this.chapterTarget.textContent = step.dataset.chapter
    this.progressTarget.style.width = `${((this.index + 1) / this.stepTargets.length) * 100}%`
    this.prevTarget.disabled = this.index === 0
    this.nextTarget.disabled = this.index === last

    history.replaceState(null, "", `#${step.id}`)
    if (scroll && step.getBoundingClientRect().top < 0) step.scrollIntoView({ block: "start", behavior: "smooth" })
  }
}
